 <!-- 设置页面 -->
<template>
  <div class="about-wrap">
    <common-head title="关于" />
    <div class="content">
        <img class="app-icon" src="@/assets/images/logo.png">
        <p>版本号：{{versionName}}</p>
    </div>
  </div>
</template>
<script>
import CommonHead from 'components/CommonHead'

export default {
  name:'User',
  components: {
    CommonHead
  },
  data() {
    return {
      versionName: ''
    }
  },
  created() {
    this.getAppList()
  },
  methods: {
    getAppList(){
      let versionName = window.AndroidWebView.getAppVersion()
      this.versionName = versionName
    },
    
  }
}
</script>
<style lang="less" scoped>
.about-wrap {
    .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .app-icon {
            margin: 50px 0 20px;
            width: 68px;
            width: 68px;
        }
    }
}



</style>